export const MAX_DOCUMENT_FILE_SIZE_MB = 15;
export const MAX_DOCUMENT_FILE_SIZE_BYTES = MAX_DOCUMENT_FILE_SIZE_MB * 1024 * 1024;
